function toSafeArray(value) {
  return Array.isArray(value) ? value : [];
}

function resolveVehicleId(routeData) {
  if (routeData === null || routeData === undefined) return "";
  return routeData.vehicle_id || "";
}

function isUnassignedBoard(board) {
  return board?.id === "_unassigned";
}

export function getAvailableRouteVehicleOptions(routeBoards, vehicleOptions) {
  const usedVehicleIds = new Set(
    toSafeArray(routeBoards)
      .filter(
        (routeBoard) =>
          !isUnassignedBoard(routeBoard) && !routeBoard?.isPlaceholder
      )
      .map((routeBoard) => resolveVehicleId(routeBoard?.apiRoute))
      .filter(Boolean)
  );

  return toSafeArray(vehicleOptions).filter(
    (vehicleOption) => !usedVehicleIds.has(vehicleOption?.value)
  );
}
